import React, { useEffect, useState } from 'react';

const SplashScreen = ({ onFinish }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade out after 1.2 seconds
    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, 1200);

    // Call onFinish after fade out completes
    const finishTimer = setTimeout(() => {
      onFinish();
    }, 1500);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(finishTimer);
    };
  }, [onFinish]);

  return (
    <div 
      className={`fixed inset-0 bg-gradient-to-br from-slate-50 via-teal-50 to-slate-100 flex items-center justify-center z-50 transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="text-center animate-fade-in">
        {/* White circle background for logo */}
        <div className="w-72 h-72 mx-auto mb-8 bg-white rounded-full shadow-2xl flex items-center justify-center animate-slide-up">
          <img 
            src="https://customer-assets.emergentagent.com/job_proposal-builder-8/artifacts/n1a2dzsn_1.%20cleanifax_logo_without_tagline-2.png"
            alt="Cleanifax Logo"
            className="w-56 h-auto"
          />
        </div>
        <p className="text-[#247C75] text-2xl font-bold animate-slide-up-delay">
          Final Clean for Every Build
        </p>
      </div>
    </div>
  );
};

export default SplashScreen;